var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9600abc4fdebd0f985dbfbc1a7d3039a4d63a754"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yunnanzhiye-pc-web"]={id:"9600abc4fdebd0f985dbfbc1a7d3039a4d63a754"};
      